import { themeQuartz } from 'ag-grid-community';

const defaultParams = {
  fontFamily: 'var(--font-family)',
  fontSize: 'var(--text-table-cell)',
  cellTextColor: 'var(--table-cell-text)',
  rowBorder: true,
  columnBorder: false,
  wrapperBorder: false,
  backgroundColor: 'var(--background)',
  foregroundColor: 'var(--foreground)',
  borderColor: 'var(--border)',
  rowHoverColor: 'var(--table-row-hover-bg)',
  menuBackgroundColor: 'var(--popover)',
  menuTextColor: 'var(--popover-foreground)',
  menuSeparatorColor: 'var(--border)',
  headerBackgroundColor: 'var(--muted)',
  headerTextColor: 'var(--foreground)',
  headerFontSize: 'var(--text-xxxsm)',
  headerFontWeight: 'var(--weight-medium)',
  headerHeight: 'var(--s-10)',
  accentColor: 'var(--primary)',
  checkboxCheckedShapeColor: 'var(--primary-foreground)',
  cellHorizontalPaddingScale: 0.5,
  rowVerticalPaddingScale: 1,
  borderRadius: 0,
  colorPickerColorBorderRadius: 0,
  colorPickerTrackBorderRadius: 0,
  iconButtonBorderRadius: 0,
  wrapperBorderRadius: 0,
};

export const oiTheme = themeQuartz.withParams(defaultParams);

export const oiErrorTheme = themeQuartz.withParams({
  ...defaultParams,
  rowBorder: false,
  rowHoverColor: 'transparent',
});
